// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  width: 100%
}

@media (min-width: 640px) {
  .container {
    max-width: 640px
  }
}

@media (min-width: 768px) {
  .container {
    max-width: 768px
  }
}

@media (min-width: 1024px) {
  .container {
    max-width: 1024px
  }
}

@media (min-width: 1280px) {
  .container {
    max-width: 1280px
  }
}

@media (min-width: 1536px) {
  .container {
    max-width: 1536px
  }
}

.pointer-events-none {
  pointer-events: none
}

.invisible {
  visibility: hidden
}

.collapse {
  visibility: collapse
}

.fixed {
  position: fixed
}

.absolute {
  position: absolute
}

.relative {
  position: relative
}

.inset-0 {
  inset: 0px
}

.left-3 {
  left: 0.75rem
}

.top-0 {
  top: 0px
}

.z-10 {
  z-index: 10
}

.float-right {
  float: right
}

.m-0 {
  margin: 0px
}

.m-auto {
  margin: auto
}

.mx-2 {
  margin-left: 0.5rem;
  margin-right: 0.5rem
}

.mx-auto {
  margin-left: auto;
  margin-right: auto
}

.my-5 {
  margin-top: 1.25rem;
  margin-bottom: 1.25rem
}

.mb-0 {
  margin-bottom: 0px
}

.mb-3 {
  margin-bottom: 0.75rem
}

.mb-4 {
  margin-bottom: 1rem
}

.mb-5 {
  margin-bottom: 1.25rem
}

.me-1 {
  margin-inline-end: 0.25rem
}

.me-2 {
  margin-inline-end: 0.5rem
}

.mr-10 {
  margin-right: 2.5rem
}

.ms-1 {
  margin-inline-start: 0.25rem
}

.ms-2 {
  margin-inline-start: 0.5rem
}

.ms-auto {
  margin-inline-start: auto
}

.mt-0 {
  margin-top: 0px
}

.mt-1 {
  margin-top: 0.25rem
}

.mt-2 {
  margin-top: 0.5rem
}

.mt-3 {
  margin-top: 0.75rem
}

.mt-4 {
  margin-top: 1rem
}

.mt-5 {
  margin-top: 1.25rem
}

.block {
  display: block
}

.inline-block {
  display: inline-block
}

.inline {
  display: inline
}

.flex {
  display: flex
}

.\\!table {
  display: table !important
}

.table {
  display: table
}

.table-column {
  display: table-column
}

.table-row {
  display: table-row
}

.grid {
  display: grid
}

.hidden {
  display: none
}

.h-\\[50\\%\\] {
  height: 50%
}

.h-full {
  height: 100%
}

.w-\\[50\\%\\] {
  width: 50%
}

.w-full {
  width: 100%
}

.shrink {
  flex-shrink: 1
}

.grow {
  flex-grow: 1
}

.origin-top-left {
  transform-origin: top left
}

.rotate-45 {
  --tw-rotate: 45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))
}

.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))
}

@keyframes pulse {
  50% {
    opacity: .5
  }
}

.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite
}

.cursor-default {
  cursor: default
}

.cursor-move {
  cursor: move
}

.cursor-pointer {
  cursor: pointer
}

.cursor-text {
  cursor: text
}

.select-all {
  -webkit-user-select: all;
     -moz-user-select: all;
          user-select: all
}

.resize {
  resize: both
}

.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr))
}

.flex-col {
  flex-direction: column
}

.flex-nowrap {
  flex-wrap: nowrap
}

.items-center {
  align-items: center
}

.justify-center {
  justify-content: center
}

.gap-4 {
  gap: 1rem
}

.gap-x-5 {
  -moz-column-gap: 1.25rem;
       column-gap: 1.25rem
}

.space-x-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)))
}

.space-x-3 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.75rem * var(--tw-space-x-reverse));
  margin-left: calc(0.75rem * calc(1 - var(--tw-space-x-reverse)))
}

.space-x-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(1rem * var(--tw-space-x-reverse));
  margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)))
}

.space-y-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse))
}

.overflow-x-scroll {
  overflow-x: scroll
}

.border {
  border-width: 1px
}

.border-solid {
  border-style: solid
}

.border-none {
  border-style: none
}

.border-slate-500 {
  --tw-border-opacity: 1;
  border-color: rgb(100 116 139 / var(--tw-border-opacity))
}

.border-slate-600 {
  --tw-border-opacity: 1;
  border-color: rgb(71 85 105 / var(--tw-border-opacity))
}

.border-transparent {
  border-color: transparent
}

.bg-green-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(22 163 74 / var(--tw-bg-opacity))
}

.bg-red-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity))
}

.p-0 {
  padding: 0px
}

.p-2 {
  padding: 0.5rem
}

.p-3 {
  padding: 0.75rem
}

.p-4 {
  padding: 1rem
}

.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem
}

.px-4 {
  padding-left: 1rem;
  padding-right: 1rem
}

.px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem
}

.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem
}

.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem
}

.ps-2 {
  padding-inline-start: 0.5rem
}

.pt-2 {
  padding-top: 0.5rem
}

.pt-5 {
  padding-top: 1.25rem
}

.text-center {
  text-align: center
}

.align-middle {
  vertical-align: middle
}

.text-8xl {
  font-size: 6rem;
  line-height: 1
}

.text-base {
  font-size: 1rem;
  line-height: 1.5rem
}

.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem
}

.italic {
  font-style: italic
}

.text-green-600 {
  --tw-text-opacity: 1;
  color: rgb(22 163 74 / var(--tw-text-opacity))
}

.text-slate-900 {
  --tw-text-opacity: 1;
  color: rgb(15 23 42 / var(--tw-text-opacity))
}

.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity))
}

.underline {
  text-decoration-line: underline
}

.overline {
  text-decoration-line: overline
}

.opacity-60 {
  opacity: 0.6
}

.opacity-80 {
  opacity: 0.8
}

.shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)
}

.shadow-none {
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)
}

.outline {
  outline-style: solid
}

.ring {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000)
}

.blur {
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)
}

.grayscale {
  --tw-grayscale: grayscale(100%);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)
}

.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)
}

.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms
}

.hover\\:cursor-pointer:hover {
  cursor: pointer
}

.hover\\:border-slate-800:hover {
  --tw-border-opacity: 1;
  border-color: rgb(30 41 59 / var(--tw-border-opacity))
}

.hover\\:opacity-80:hover {
  opacity: 0.8
}

@media (min-width: 640px) {
  .sm\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr))
  }

  .sm\\:gap-2 {
    gap: 0.5rem
  }
}

@media (min-width: 768px) {
  .md\\:my-7 {
    margin-top: 1.75rem;
    margin-bottom: 1.75rem
  }

  .md\\:h-full {
    height: 100%
  }

  .md\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr))
  }

  .md\\:flex-row {
    flex-direction: row
  }

  .md\\:gap-4 {
    gap: 1rem
  }

  .md\\:space-x-2 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(0.5rem * var(--tw-space-x-reverse));
    margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)))
  }

  .md\\:space-y-0 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0px * var(--tw-space-y-reverse))
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/scss/vendor/tailwind/output.css"],"names":[],"mappings":"AAAA;EACE;AACF;;AAEA;EACE;IACE;EACF;AACF;;AAEA;EACE;IACE;EACF;AACF;;AAEA;EACE;IACE;EACF;AACF;;AAEA;EACE;IACE;EACF;AACF;;AAEA;EACE;IACE;EACF;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,mBAAmB;EACnB;AACF;;AAEA;EACE,iBAAiB;EACjB;AACF;;AAEA;EACE,mBAAmB;EACnB;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,kBAAkB;EAClB;AACF;;AAEA;EACE;AACF;;AAEA;EACE;IACE;EACF;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,wBAAwB;KACrB,qBAAqB;UAChB;AACV;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,wBAAwB;OACnB;AACP;;AAEA;EACE,uBAAuB;EACvB,sDAAsD;EACtD;AACF;;AAEA;EACE,uBAAuB;EACvB,uDAAuD;EACvD;AACF;;AAEA;EACE,uBAAuB;EACvB,oDAAoD;EACpD;AACF;;AAEA;EACE,uBAAuB;EACvB,8DAA8D;EAC9D;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,sBAAsB;EACtB;AACF;;AAEA;EACE,sBAAsB;EACtB;AACF;;AAEA;EACE;AACF;;AAEA;EACE,kBAAkB;EAClB;AACF;;AAEA;EACE,kBAAkB;EAClB;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,qBAAqB;EACrB;AACF;;AAEA;EACE,kBAAkB;EAClB;AACF;;AAEA;EACE,qBAAqB;EACrB;AACF;;AAEA;EACE,mBAAmB;EACnB;AACF;;AAEA;EACE,oBAAoB;EACpB;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,eAAe;EACf;AACF;;AAEA;EACE,eAAe;EACf;AACF;;AAEA;EACE,mBAAmB;EACnB;AACF;;AAEA;EACE;AACF;;AAEA;EACE,oBAAoB;EACpB;AACF;;AAEA;EACE,oBAAoB;EACpB;AACF;;AAEA;EACE,oBAAoB;EACpB;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,0EAA0E;EAC1E,8FAA8F;EAC9F;AACF;;AAEA;EACE,sBAAsB;EACtB,8BAA8B;EAC9B;AACF;;AAEA;EACE;AACF;;AAEA;EACE,2GAA2G;EAC3G,yGAAyG;EACzG;AACF;;AAEA;EACE,oBAAoB;EACpB;AACF;;AAEA;EACE,+BAA+B;EAC/B;AACF;;AAEA;EACE;AACF;;AAEA;EACE,gKAAgK;EAChK,wJAAwJ;EACxJ,iLAAiL;EACjL,wDAAwD;EACxD;AACF;;AAEA;EACE;AACF;;AAEA;EACE,sBAAsB;EACtB;AACF;;AAEA;EACE;AACF;;AAEA;EACE;IACE;EACF;;EAEA;IACE;EACF;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB;EACF;;EAEA;IACE;EACF;;EAEA;IACE;EACF;;EAEA;IACE;EACF;;EAEA;IACE;EACF;;EAEA;IACE,uBAAuB;IACvB,sDAAsD;IACtD;EACF;;EAEA;IACE,uBAAuB;IACvB,2DAA2D;IAC3D;EACF;AACF","sourcesContent":[".container {\n  width: 100%\n}\n\n@media (min-width: 640px) {\n  .container {\n    max-width: 640px\n  }\n}\n\n@media (min-width: 768px) {\n  .container {\n    max-width: 768px\n  }\n}\n\n@media (min-width: 1024px) {\n  .container {\n    max-width: 1024px\n  }\n}\n\n@media (min-width: 1280px) {\n  .container {\n    max-width: 1280px\n  }\n}\n\n@media (min-width: 1536px) {\n  .container {\n    max-width: 1536px\n  }\n}\n\n.pointer-events-none {\n  pointer-events: none\n}\n\n.invisible {\n  visibility: hidden\n}\n\n.collapse {\n  visibility: collapse\n}\n\n.fixed {\n  position: fixed\n}\n\n.absolute {\n  position: absolute\n}\n\n.relative {\n  position: relative\n}\n\n.inset-0 {\n  inset: 0px\n}\n\n.left-3 {\n  left: 0.75rem\n}\n\n.top-0 {\n  top: 0px\n}\n\n.z-10 {\n  z-index: 10\n}\n\n.float-right {\n  float: right\n}\n\n.m-0 {\n  margin: 0px\n}\n\n.m-auto {\n  margin: auto\n}\n\n.mx-2 {\n  margin-left: 0.5rem;\n  margin-right: 0.5rem\n}\n\n.mx-auto {\n  margin-left: auto;\n  margin-right: auto\n}\n\n.my-5 {\n  margin-top: 1.25rem;\n  margin-bottom: 1.25rem\n}\n\n.mb-0 {\n  margin-bottom: 0px\n}\n\n.mb-3 {\n  margin-bottom: 0.75rem\n}\n\n.mb-4 {\n  margin-bottom: 1rem\n}\n\n.mb-5 {\n  margin-bottom: 1.25rem\n}\n\n.me-1 {\n  margin-inline-end: 0.25rem\n}\n\n.me-2 {\n  margin-inline-end: 0.5rem\n}\n\n.mr-10 {\n  margin-right: 2.5rem\n}\n\n.ms-1 {\n  margin-inline-start: 0.25rem\n}\n\n.ms-2 {\n  margin-inline-start: 0.5rem\n}\n\n.ms-auto {\n  margin-inline-start: auto\n}\n\n.mt-0 {\n  margin-top: 0px\n}\n\n.mt-1 {\n  margin-top: 0.25rem\n}\n\n.mt-2 {\n  margin-top: 0.5rem\n}\n\n.mt-3 {\n  margin-top: 0.75rem\n}\n\n.mt-4 {\n  margin-top: 1rem\n}\n\n.mt-5 {\n  margin-top: 1.25rem\n}\n\n.block {\n  display: block\n}\n\n.inline-block {\n  display: inline-block\n}\n\n.inline {\n  display: inline\n}\n\n.flex {\n  display: flex\n}\n\n.\\!table {\n  display: table !important\n}\n\n.table {\n  display: table\n}\n\n.table-column {\n  display: table-column\n}\n\n.table-row {\n  display: table-row\n}\n\n.grid {\n  display: grid\n}\n\n.hidden {\n  display: none\n}\n\n.h-\\[50\\%\\] {\n  height: 50%\n}\n\n.h-full {\n  height: 100%\n}\n\n.w-\\[50\\%\\] {\n  width: 50%\n}\n\n.w-full {\n  width: 100%\n}\n\n.shrink {\n  flex-shrink: 1\n}\n\n.grow {\n  flex-grow: 1\n}\n\n.origin-top-left {\n  transform-origin: top left\n}\n\n.rotate-45 {\n  --tw-rotate: 45deg;\n  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))\n}\n\n.transform {\n  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))\n}\n\n@keyframes pulse {\n  50% {\n    opacity: .5\n  }\n}\n\n.animate-pulse {\n  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite\n}\n\n.cursor-default {\n  cursor: default\n}\n\n.cursor-move {\n  cursor: move\n}\n\n.cursor-pointer {\n  cursor: pointer\n}\n\n.cursor-text {\n  cursor: text\n}\n\n.select-all {\n  -webkit-user-select: all;\n     -moz-user-select: all;\n          user-select: all\n}\n\n.resize {\n  resize: both\n}\n\n.grid-cols-2 {\n  grid-template-columns: repeat(2, minmax(0, 1fr))\n}\n\n.flex-col {\n  flex-direction: column\n}\n\n.flex-nowrap {\n  flex-wrap: nowrap\n}\n\n.items-center {\n  align-items: center\n}\n\n.justify-center {\n  justify-content: center\n}\n\n.gap-4 {\n  gap: 1rem\n}\n\n.gap-x-5 {\n  -moz-column-gap: 1.25rem;\n       column-gap: 1.25rem\n}\n\n.space-x-2 > :not([hidden]) ~ :not([hidden]) {\n  --tw-space-x-reverse: 0;\n  margin-right: calc(0.5rem * var(--tw-space-x-reverse));\n  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)))\n}\n\n.space-x-3 > :not([hidden]) ~ :not([hidden]) {\n  --tw-space-x-reverse: 0;\n  margin-right: calc(0.75rem * var(--tw-space-x-reverse));\n  margin-left: calc(0.75rem * calc(1 - var(--tw-space-x-reverse)))\n}\n\n.space-x-4 > :not([hidden]) ~ :not([hidden]) {\n  --tw-space-x-reverse: 0;\n  margin-right: calc(1rem * var(--tw-space-x-reverse));\n  margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)))\n}\n\n.space-y-2 > :not([hidden]) ~ :not([hidden]) {\n  --tw-space-y-reverse: 0;\n  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));\n  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse))\n}\n\n.overflow-x-scroll {\n  overflow-x: scroll\n}\n\n.border {\n  border-width: 1px\n}\n\n.border-solid {\n  border-style: solid\n}\n\n.border-none {\n  border-style: none\n}\n\n.border-slate-500 {\n  --tw-border-opacity: 1;\n  border-color: rgb(100 116 139 / var(--tw-border-opacity))\n}\n\n.border-slate-600 {\n  --tw-border-opacity: 1;\n  border-color: rgb(71 85 105 / var(--tw-border-opacity))\n}\n\n.border-transparent {\n  border-color: transparent\n}\n\n.bg-green-600 {\n  --tw-bg-opacity: 1;\n  background-color: rgb(22 163 74 / var(--tw-bg-opacity))\n}\n\n.bg-red-600 {\n  --tw-bg-opacity: 1;\n  background-color: rgb(220 38 38 / var(--tw-bg-opacity))\n}\n\n.p-0 {\n  padding: 0px\n}\n\n.p-2 {\n  padding: 0.5rem\n}\n\n.p-3 {\n  padding: 0.75rem\n}\n\n.p-4 {\n  padding: 1rem\n}\n\n.px-3 {\n  padding-left: 0.75rem;\n  padding-right: 0.75rem\n}\n\n.px-4 {\n  padding-left: 1rem;\n  padding-right: 1rem\n}\n\n.px-5 {\n  padding-left: 1.25rem;\n  padding-right: 1.25rem\n}\n\n.py-2 {\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem\n}\n\n.py-3 {\n  padding-top: 0.75rem;\n  padding-bottom: 0.75rem\n}\n\n.ps-2 {\n  padding-inline-start: 0.5rem\n}\n\n.pt-2 {\n  padding-top: 0.5rem\n}\n\n.pt-5 {\n  padding-top: 1.25rem\n}\n\n.text-center {\n  text-align: center\n}\n\n.align-middle {\n  vertical-align: middle\n}\n\n.text-8xl {\n  font-size: 6rem;\n  line-height: 1\n}\n\n.text-base {\n  font-size: 1rem;\n  line-height: 1.5rem\n}\n\n.text-lg {\n  font-size: 1.125rem;\n  line-height: 1.75rem\n}\n\n.italic {\n  font-style: italic\n}\n\n.text-green-600 {\n  --tw-text-opacity: 1;\n  color: rgb(22 163 74 / var(--tw-text-opacity))\n}\n\n.text-slate-900 {\n  --tw-text-opacity: 1;\n  color: rgb(15 23 42 / var(--tw-text-opacity))\n}\n\n.text-white {\n  --tw-text-opacity: 1;\n  color: rgb(255 255 255 / var(--tw-text-opacity))\n}\n\n.underline {\n  text-decoration-line: underline\n}\n\n.overline {\n  text-decoration-line: overline\n}\n\n.opacity-60 {\n  opacity: 0.6\n}\n\n.opacity-80 {\n  opacity: 0.8\n}\n\n.shadow {\n  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);\n  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);\n  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)\n}\n\n.shadow-none {\n  --tw-shadow: 0 0 #0000;\n  --tw-shadow-colored: 0 0 #0000;\n  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)\n}\n\n.outline {\n  outline-style: solid\n}\n\n.ring {\n  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);\n  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);\n  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000)\n}\n\n.blur {\n  --tw-blur: blur(8px);\n  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)\n}\n\n.grayscale {\n  --tw-grayscale: grayscale(100%);\n  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)\n}\n\n.filter {\n  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)\n}\n\n.transition {\n  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;\n  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;\n  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  transition-duration: 150ms\n}\n\n.hover\\:cursor-pointer:hover {\n  cursor: pointer\n}\n\n.hover\\:border-slate-800:hover {\n  --tw-border-opacity: 1;\n  border-color: rgb(30 41 59 / var(--tw-border-opacity))\n}\n\n.hover\\:opacity-80:hover {\n  opacity: 0.8\n}\n\n@media (min-width: 640px) {\n  .sm\\:grid-cols-2 {\n    grid-template-columns: repeat(2, minmax(0, 1fr))\n  }\n\n  .sm\\:gap-2 {\n    gap: 0.5rem\n  }\n}\n\n@media (min-width: 768px) {\n  .md\\:my-7 {\n    margin-top: 1.75rem;\n    margin-bottom: 1.75rem\n  }\n\n  .md\\:h-full {\n    height: 100%\n  }\n\n  .md\\:grid-cols-4 {\n    grid-template-columns: repeat(4, minmax(0, 1fr))\n  }\n\n  .md\\:flex-row {\n    flex-direction: row\n  }\n\n  .md\\:gap-4 {\n    gap: 1rem\n  }\n\n  .md\\:space-x-2 > :not([hidden]) ~ :not([hidden]) {\n    --tw-space-x-reverse: 0;\n    margin-right: calc(0.5rem * var(--tw-space-x-reverse));\n    margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)))\n  }\n\n  .md\\:space-y-0 > :not([hidden]) ~ :not([hidden]) {\n    --tw-space-y-reverse: 0;\n    margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse)));\n    margin-bottom: calc(0px * var(--tw-space-y-reverse))\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
